import React from 'react';

export default function TotalTenPromo() {
  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      backgroundColor: '#1E201E',
      backgroundImage: `
        repeating-linear-gradient(
          45deg,
          transparent,
          transparent 10px,
          rgba(255,255,255,0.01) 10px,
          rgba(255,255,255,0.01) 11px
        ),
        repeating-linear-gradient(
          -45deg,
          transparent,
          transparent 10px,
          rgba(0,0,0,0.02) 10px,
          rgba(0,0,0,0.02) 11px
        )
      `,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      overflow: 'hidden',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Rubik", system-ui, sans-serif',
    }}>
      
      {/* Floating background tiles */}
      {[
        { top: '10%', left: '8%', size: 70, delay: 0 },
        { top: '65%', left: '5%', size: 50, delay: 2 },
        { top: '25%', right: '10%', size: 60, delay: 1 },
        { bottom: '20%', right: '12%', size: 55, delay: 3 },
      ].map((tile, i) => (
        <div
          key={i}
          className="bg-tile"
          style={{
            position: 'absolute',
            ...tile,
            width: tile.size,
            height: tile.size,
            backgroundColor: '#FFDD93',
            borderRadius: 8,
            opacity: 0.05,
            boxShadow: 'inset 0 2px 0 rgba(255, 255, 255, 0.2), 0 3px 0 rgba(201, 168, 94, 0.3)',
            animation: `float 20s infinite ease-in-out ${tile.delay}s`,
          }}
        />
      ))}

      {/* Main content */}
      <div className="main-content" style={{
        textAlign: 'center',
        zIndex: 10,
        animation: 'fadeIn 1s ease-out',
      }}>
        
        {/* Title */}
        <h1 className="title" style={{
          fontSize: 120,
          fontWeight: 800,
          color: '#ECDFCC',
          margin: 0,
          marginBottom: 15,
          letterSpacing: -3,
          textShadow: '0 4px 30px rgba(255, 221, 147, 0.2)',
        }}>
          Total Ten
        </h1>
        
        {/* Chinese subtitle */}
        <div className="subtitle" style={{
          fontSize: 32,
          color: '#FFDD93',
          fontWeight: 500,
          letterSpacing: 10,
          marginBottom: 80,
          opacity: 0.9,
        }}>
          幸运十点
        </div>

        {/* Game demo */}
        <div className="game-demo" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 40,
          marginBottom: 80,
        }}>
          
          {/* Three tiles */}
          <div className="tiles-container" style={{
            display: 'flex',
            gap: 15,
          }}>
            {[3, 2, 5].map((num, i) => (
              <div
                key={i}
                className="tile"
                style={{
                  width: 120,
                  height: 120,
                  backgroundColor: '#FFDD93',
                  borderRadius: 12,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 80,
                  fontWeight: 700,
                  fontFamily: 'Rubik, sans-serif',
                  color: '#1E201E',
                  boxShadow: `
                    inset 0 3px 0 rgba(255, 255, 255, 0.5),
                    inset 0 -3px 0 rgba(0, 0, 0, 0.15),
                    0 6px 0 #c9a85e,
                    0 10px 20px rgba(0, 0, 0, 0.5)
                  `,
                  animation: `tileAppear 0.6s ease-out backwards ${0.1 * (i + 1)}s`,
                }}
              >
                {num}
              </div>
            ))}
          </div>

          {/* Equals sign */}
          <div className="equals" style={{
            fontSize: 72,
            fontWeight: 700,
            color: '#FFDD93',
            animation: 'fadeIn 1s ease-out 0.5s backwards',
          }}>
            =
          </div>

          {/* Result */}
          <div className="result" style={{
            fontSize: 96,
            fontWeight: 800,
            color: '#FFDD93',
            textShadow: '0 4px 30px rgba(255, 221, 147, 0.4)',
            animation: 'pulse 2s infinite ease-in-out, fadeIn 1s ease-out 0.6s backwards',
          }}>
            10
          </div>
        </div>

        {/* Tagline */}
        <div className="tagline" style={{
          fontSize: 44,
          fontWeight: 600,
          color: '#ECDFCC',
          marginBottom: 15,
          animation: 'fadeInUp 1s ease-out 0.8s backwards',
        }}>
          Clear the Board. Find the Sum.
        </div>
        
        <div className="sub-tagline" style={{
          fontSize: 28,
          color: '#FFDD93',
          fontWeight: 400,
          marginBottom: 60,
          opacity: 0.85,
          animation: 'fadeInUp 1s ease-out 1s backwards',
        }}>
          The Addictive Number Puzzle
        </div>

        {/* Features */}
        <div className="features" style={{
          display: 'flex',
          gap: 100,
          justifyContent: 'center',
        }}>
          {[
            { icon: '🧠', text: 'Think Fast' },
            { icon: '⚡', text: 'Play Anywhere' },
            { icon: '🎯', text: 'Master the Ten' },
          ].map((feature, i) => (
            <div
              key={i}
              style={{
                textAlign: 'center',
                animation: `fadeInUp 1s ease-out ${1.2 + i * 0.2}s backwards`,
              }}
            >
              <div className="feature-icon" style={{ fontSize: 56, marginBottom: 12 }}>{feature.icon}</div>
              <div className="feature-text" style={{
                fontSize: 22,
                color: '#FFDD93',
                fontWeight: 500,
                opacity: 0.9,
              }}>
                {feature.text}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
          }
          25% {
            transform: translateY(-30px) rotate(5deg);
          }
          50% {
            transform: translateY(-50px) rotate(-5deg);
          }
          75% {
            transform: translateY(-30px) rotate(3deg);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes tileAppear {
          from {
            transform: translateY(-40px) scale(0.8);
            opacity: 0;
          }
          to {
            transform: translateY(0) scale(1);
            opacity: 1;
          }
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }

        @media (max-width: 768px) {
          .main-content {
            padding: 0 1rem;
          }
          
          .title {
            font-size: 64px !important;
            letter-spacing: -2px !important;
            margin-bottom: 10px !important;
          }
          
          .subtitle {
            font-size: 20px !important;
            letter-spacing: 6px !important;
            margin-bottom: 50px !important;
          }
          
          .game-demo {
            gap: 20px !important;
            margin-bottom: 50px !important;
          }
          
          .tiles-container {
            gap: 10px !important;
          }
          
          .tile {
            width: 70px !important;
            height: 70px !important;
            font-size: 48px !important;
            border-radius: 8px !important;
          }
          
          .equals {
            font-size: 48px !important;
          }
          
          .result {
            font-size: 64px !important;
          }
          
          .tagline {
            font-size: 28px !important;
            margin-bottom: 10px !important;
          }
          
          .sub-tagline {
            font-size: 18px !important;
            margin-bottom: 40px !important;
          }
          
          .features {
            gap: 40px !important;
          }
          
          .feature-icon {
            font-size: 40px !important;
            margin-bottom: 8px !important;
          }
          
          .feature-text {
            font-size: 16px !important;
          }
          
          .bg-tile {
            display: none;
          }
        }

        @media (max-width: 480px) {
          .title {
            font-size: 48px !important;
          }
          
          .subtitle {
            font-size: 16px !important;
            letter-spacing: 4px !important;
          }
          
          .game-demo {
            gap: 15px !important;
          }
          
          .tiles-container {
            gap: 8px !important;
          }
          
          .tile {
            width: 60px !important;
            height: 60px !important;
            font-size: 40px !important;
          }
          
          .equals {
            font-size: 40px !important;
          }
          
          .result {
            font-size: 52px !important;
          }
          
          .tagline {
            font-size: 22px !important;
          }
          
          .sub-tagline {
            font-size: 16px !important;
          }
          
          .features {
            gap: 30px !important;
          }
          
          .feature-icon {
            font-size: 32px !important;
          }
          
          .feature-text {
            font-size: 14px !important;
          }
        }
      `}</style>
    </div>
  );
}